export const noPage = {
  "name": "noPage",
  "elements": [
    {
      "type": "html",
      "name": "noHtml",
      "html": "<h3>It's a journey together</h3><p>Every longevity journey starts with a commitment to care and respect for your data. If you do not agree to our Privacy Policy, we cannot begin this process together. We hope you'll reconsider, so we can walk this path toward health and vitality by your side. You can start over anytime using the Restart button in the top right corner.</p>"
    }
  ]
};